import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

type QualityAction = {
  label: string;
  path?: string;
  enabled: boolean;
};

type QualityCard = {
  title: string;
  description: string;
  primaryAction: QualityAction;
};

function ArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </svg>
  );
}

export function QualityPage() {
  const { canRead } = useAuth();

  const cards: QualityCard[] = [
    {
      title: 'Rutiner / SOP',
      description: 'Policyer, instruktioner och bilagor för process och livsmedelssäkerhet.',
      primaryAction: { label: 'Kvalitetspärm', path: '/quality/docs', enabled: canRead('quality') },
    },
    {
      title: 'Faroanalys',
      description: 'Koppla faror till kapitel och processsteg, filtrera per kapitel och skriv ut sammanställning.',
      primaryAction: { label: 'Till faroanalys', path: '/quality/hazards', enabled: canRead('quality') },
    },
    {
      title: 'Besökar-/introduktionslogg',
      description: 'Sign-off för hygien, hårskydd och smycken vid introduktion i lokalen.',
      primaryAction: { label: 'Till besökslogg', path: '/quality/visitors', enabled: canRead('quality') },
    },
    {
      title: 'Egenkontrollchecklistor',
      description: 'Kritiska styrpunkter, städning, kalibrering, underhåll, skadedjur och andra rutinkontroller.',
      primaryAction: { label: 'Till egenkontroll', path: '/quality/selfchecks?type=ccp', enabled: canRead('quality') },
    },
  ];

  return (
    <div className="space-y-5">
      <div className="space-y-2">
        <h1 className="text-[26px] font-semibold tracking-[-0.03em] text-slate-950 md:text-[30px]">Kvalitet</h1>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {cards.map((card) => (
          <div
            key={card.title}
            className="group flex min-h-[220px] flex-col rounded-[28px] border border-slate-300 bg-white px-5 py-5 shadow-[0_10px_30px_rgba(15,23,42,0.05)] transition duration-200 hover:-translate-y-0.5 hover:shadow-[0_18px_40px_rgba(15,23,42,0.08)]"
          >
            <div className="mb-4">
              <div className="text-[18px] font-semibold tracking-[-0.02em] text-slate-950 md:text-[20px]">{card.title}</div>
            </div>

            <p className="text-[14px] leading-8 text-slate-600 md:text-[15px]">{card.description}</p>

            <div className="mt-auto pt-5">
              {card.primaryAction.enabled && card.primaryAction.path ? (
                <Link to={card.primaryAction.path} className="inline-flex items-center gap-2 text-base font-semibold text-primary hover:text-primary-hover">
                  <span>{card.primaryAction.label}</span>
                  <ArrowIcon />
                </Link>
              ) : (
                <span className="inline-flex items-center gap-2 text-base font-semibold text-slate-400">
                  <span>{card.primaryAction.label}</span>
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
